module.exports = __webpack_public_path__ + "img/zigbee-repeater-sm.a36dbf39.svg";